import React, { FunctionComponent, useState } from "react";
import {
  Table,
  Tooltip,
  Grid,
  Fab,
  Button,  
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Switch from "@material-ui/core/Switch";
import EditIcon from "@material-ui/icons/Edit";
import MUIDataTable from "mui-datatables";
import { useRoleStyles } from "../../useRoleStyles";
import { useStore } from "../../../../store";
import { SnackBar } from "../../../SnackBar";
import { useTableStyles } from "../../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Description",
  "",
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface RolesTableProps {
  roleslist: any;
  setEditRow: (data: any) => void;
  editRolePermission: boolean;
  maxPriority: number;
}
export const RolesTableList: FunctionComponent<RolesTableProps> = ({
  roleslist,
  setEditRow,
  editRolePermission,
  maxPriority
}) => {
  const classes = useRoleStyles();
  const getMuiTheme = useTableStyles();
  const [status] = useStore("status");
  const [user] = useStore("auth", "user");
  const [roles, { getRoles, updateRole }] = useStore("roles");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [oldStatus, setOldStatus] = useState<string>("");
  const [roleName, setRoleName] = useState<string>("");
  const [roleId, setRoleId] = useState<number>(0);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [roleStatus, setRoleStatus] = useState<string>("");

  const handleEdit = (id: number) => {
    const editRow = roleslist && roleslist.find((i: any) => i.id === id);
    setEditRow(editRow);
  };

  const handleChange = (id: number, stat_id: number, name: string) => {
    const status_desc =
      status && status.find((i: any) => i.id === stat_id).description;
    setOldStatus(status_desc);
    setRoleName(name);
    setRoleId(id);
    setOpenDialog(true);
  };

  const changeStatus = async () => {
    const obj = {
      status:
        oldStatus === "Active"
          ? status && status.find((i: any) => i.description === "Inactive").id
          : status && status.find((i: any) => i.description === "Active").id,
    };
    await updateRole(roleId, obj);
    await getRoles();
    setSnackbarColor("green");
    setRoleStatus("Status successfully updated");
    setOpenDialog(false);
  };

  const onCloseSnackbar = () => {
    setRoleStatus("");
  };

  if (roleslist && roleslist.length > 0) {
    return (
      <div>
        <SnackBar
          status={roleStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Roles List"}
              data={roleslist.map((role: any) => {
                return [
                  role.name,
                  role.description,
                  <Grid container direction="row" spacing={2} justify="flex-end"
                    style={{
                      display: user.is_super_admin?"":(
                        editRolePermission ? (
                          maxPriority >= role.priority_level ?
                            "none" : ""
                            ) : "none")}}>
                    <Grid item>
                      <Tooltip title={"Edit"}>
                        <Fab
                          size="small"
                          aria-label="edit"
                          color="primary"
                          className={classes.editIconMargin}
                          onClick={() => handleEdit(role.id)}
                        >
                          <EditIcon className={classes.editIcon} />
                        </Fab>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Tooltip
                        title={
                          status && status.find((i: any) => i.id === role.status) !== undefined ? (
                            status &&
                              status.find((i: any) => i.id === role.status)
                                .description === "Active"
                              ? "Change Status to Inactive"
                              : "Change Status to Active"
                          ) : ""}>
                        <Switch
                          checked={
                            status &&
                              status.find((i: any) => i.id === role.status) !== undefined ? (
                              status &&
                                status.find((i: any) => i.id === role.status)
                                  .description === "Active"
                                ? true
                                : false
                            ) : false
                          }
                          onClick={() =>
                            handleChange(role.id, role.status, role.name)
                          }
                          style={{
                            color: status &&
                              status.find((i: any) => i.id === role.status) !== undefined ? (
                              status &&
                                status.find((i: any) => i.id === role.status).description === "Active" ? "#3d5a79" : undefined
                            ) : ""}}
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {oldStatus === "Active"
                ? `Would you like to change status of ${roleName} to Inactive?`
                : `Would you like to change status of ${roleName} to Active?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => changeStatus()} id="buton">
              Yes
          </Button>
            <Button onClick={() => setOpenDialog(false)} autoFocus id="buton">
              No
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Roles List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};